import React, {useEffect, useRef, useState} from 'react';
import {selfcareChangeContactPermissions, selfcareLatestPermissionText, selfcareSetPopupIneligible} from '../../util/request';
import {useCustomer} from "../../layouts/SelfcareLayout.tsx";

interface PermissionPopupProps {
    customer_id: string;
}

interface PermissionPopupProps {
    customer_id: string;
    onClose?: () => void
}

const PermissionPopup: React.FC<PermissionPopupProps> = ({customer_id}) => {
    const [permissionText, setPermissionText] = useState<string>('');
    const {customer} = useCustomer();
    const [isVisible, setIsVisible] = useState<boolean>(true);
    const popupRef = useRef<HTMLDivElement>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null)

    useEffect(() => {
        const fetchPermissionText = async () => {
            try {
                const response = await selfcareLatestPermissionText(customer.customer_id);
                if (response.code === 200) {
                    setPermissionText(response.response.data.permission_text);
                } else {
                    console.error('Failed to fetch permission text:', response);
                }
            } catch (error) {
                console.error('Error fetching permission text:', error);
            }
        };

        fetchPermissionText();
    }, [customer]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
                setIsVisible(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [popupRef]);

    const handleClose = async () => {
        await selfcareSetPopupIneligible(customer_id);
        setIsVisible(false);
    };

    const handleHide = () => {
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    const onSubmit = () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updated_permissions: any[] = [];

        for (const propName in customer.customer_permission) {
            const permission = customer.customer_permission[propName];
            updated_permissions.push({
                "key": propName,
                "communication_channel_id": 1, // 1 = selfcare,
                "is_action_set": true,
                "permission_type_id": permission.permission_type_id,
                "permission_type_name": permission.permission_type_name,
            });
        }

        selfcareChangeContactPermissions(customer.customer_id, updated_permissions).then(r => {
            if (r.code !== 200) {
                setErrorMessage(r.response.error_message as string);
                return;
            }
            customer.customer_permission = updated_permissions.reduce((acc, permission) => {
                acc[permission.key] = {
                    permission_type_name: permission.permission_type_name,
                    permission_type_id: permission.permission_type_id,
                    is_action_set: permission.is_action_set,
                    state: [permission.is_action_set],
                };
                return acc;
            }, {});

        }).catch(() => {
            setErrorMessage('Der skete desværre en fejl. Prøv igen');
        }).finally(() => {
            setIsVisible(false);
        });
    };

    return (
        <div className="selfcare-popup-overlay">
            <div className="selfcare-popup" ref={popupRef}>
                <button className={'close-popup wl-overlay__close'} onClick={handleHide}>&times;</button>
                <h3 className={'heading--montserrat heading--left'}>
                    Giv os lov til at kontakte dig – og deltag i konkurrencen om et GoGift-gavekort på 1.000 kr.
                </h3>
                <p>
                    Få nyheder, gode råd og tilbud, når du tilmelder dig. Så deltager du automatisk 
                    i lodtrækningen om gavekortet. Vi trækker en vinder den 31. maj 2025 blandt alle 
                    tilmeldte. Vinderen får besked via telefon eller e-mail.
                </p>
                <p className="smaller" dangerouslySetInnerHTML={{ __html: permissionText }}></p>
                {errorMessage && <div className="selfcare-account-error">{errorMessage}</div>}
                <div className='buttons'>
                    <button className="confirm" onClick={onSubmit}>Ja tak!</button>
                    <button className="cancel" onClick={handleClose}>Nej tak</button>
                </div>
            </div>
        </div>
    );
};

export default PermissionPopup;
